import { lazyWithRetry as lazy } from './lazyWithRetry';
import { loadEmbedTrip } from '../pages/embed/loadEmbedTrip';

// Exported so the entry point can start fetching Layout alongside the page chunk (see index.tsx).
export const loadLayout = () => import('../layout');

export const customRoutes = {
  Layout: lazy(loadLayout),
  HomeScreen: lazy(() => import('../pages/home')),
  DashboardScreen: lazy(() => import('../pages/dashboard')),
  BrokerSalesDashboard: lazy(() => import('../pages/dashboard/BrokerSalesDashboard')),
  LeadershipDashboard: lazy(() => import('../pages/dashboard/LeadershipDashboard')),
  LeaderboardDashboard: lazy(() => import('../pages/dashboard/LeaderboardDashboard')),
  ClientAnalyticsDashboard: lazy(() => import('../pages/dashboard/ClientAnalyticsDashboard')),
  FormScreen: lazy(() => import('../pages/Form/FormValidation')),
  TeamScreen: lazy(() => import('../pages/URTManagement/team/team-screen')),

  URTManagement: lazy(() => import('../pages/URTManagement')),
  RoleManagement: lazy(() => import('../pages/URTManagement/RoleManagement')),
  TeamManagement: lazy(() => import('../pages/URTManagement/TeamManagement')),
  UserManagement: lazy(() => import('../pages/URTManagement/UserManagement')),
  AccountManagement: lazy(() => import('../pages/URTManagement/AccountManagement')),
  ConfigurationManagement: lazy(() => import('../pages/URTManagement/configuration/ConfigurationManagement')),

  FinanceTripAdministrationList: lazy(() => import('../pages/finance/trip/FinanceTripAdministrationList')),

  //  Contact
  ContactDetails: lazy(() => import('../pages/contact/contactDetails')),
  ContactDetailsDetailsTab: lazy(() => import('../pages/contact/contactDetails/details')),
  ContactDetailsTripsTab: lazy(() => import('../pages/contact/contactDetails/trips')),
  ContactDetailsJetCardsTab: lazy(() => import('../pages/contact/contactDetails/jetCards')),
  ContactDetailsFlightCreditsTab: lazy(() => import('../pages/contact/contactDetails/flightCredits')),
  ContactDetailsPassengersTab: lazy(() => import('../pages/contact/contactDetails/passengers')),
  ContactDetailsPetsTab: lazy(() => import('../pages/contact/contactDetails/pets')),
  ContactDetailsTasksTab: lazy(() => import('../pages/contact/contactDetails/tasks')),
  ContactDetailsNotesTab: lazy(() => import('../pages/contact/contactDetails/notes')),

  //  Account
  AccountDetails: lazy(() => import('../pages/account/accountDetails')),
  AccountDetailsDetailsTab: lazy(() => import('../pages/account/accountDetails/details')),
  AccountDetailsTripsTab: lazy(() => import('../pages/account/accountDetails/trips')),
  AccountDetailsJetCardsTab: lazy(() => import('../pages/account/accountDetails/jetCards')),
  AccountDetailsFlightCreditsTab: lazy(() => import('../pages/account/accountDetails/flightCredits')),
  AccountDetailsPassengersTab: lazy(() => import('../pages/account/accountDetails/passengers')),
  AccountDetailsPetsTab: lazy(() => import('../pages/account/accountDetails/pets')),
  AccountDetailsTasksTab: lazy(() => import('../pages/account/accountDetails/tasks')),
  AccountDetailsNotesTab: lazy(() => import('../pages/account/accountDetails/notes')),

  //  Trips
  TripListing: lazy(() => import('../pages/trip')),
  Calendar: lazy(() => import('../pages/calendar')),
  TripDetails: lazy(() => import('../pages/trip/tripDetails')),
  TripDetailsDetailsTab: lazy(() => import('../pages/trip/tripDetails/details')),
  TripDetailsPassengersTab: lazy(() => import('../pages/trip/tripDetails/passengers')),
  TripDetailsFinancesTab: lazy(() => import('../pages/trip/tripDetails/finances')),
  TripDetailsTasksTab: lazy(() => import('../pages/trip/tripDetails/tasks')),
  TripDetailsNotesTab: lazy(() => import('../pages/trip/tripDetails/notes')),
  TripDetailsTripReportsTab: lazy(() => import('../pages/trip/tripDetails/tripReports')),
  TripDetailsActivityHistoryTab: lazy(() => import('../pages/trip/tripDetails/activityHistory')),
  CreatTrip: lazy(() => import('../pages/trip/manageTrip/createTrip')),
  TripProposalPreviewBroker: lazy(() => import('../pages/trip/manageTrip/proposalPreview/broker/proposal')),
  TripProposalPreviewClient: lazy(() => import('../pages/trip/manageTrip/proposalPreview/client/proposal')),
  TripProposalPreviewClientRecipient: lazy(() => import('../pages/trip/manageTrip/proposalPreview/client/proposal/ClientReviewRecipient')),
  TripProposalClientPreliminaryInvoice: lazy(() => import('../pages/trip/manageTrip/proposalPreview/client/invoice/ClientPreliminaryInvoice')),
  TripProposalClientInvoice: lazy(() => import('../pages/trip/manageTrip/proposalPreview/client/invoice/ClientInvoice')),
  TripFeedbackClient: lazy(() => import('../pages/clientFeedback')),
  TripFeedbackBroker: lazy(() => import('../pages/clientFeedback/BrokerReview')),
  ManageTrip: lazy(() => import('../pages/trip/manageTrip')),

  //  Finance
  Finance: lazy(() => import('../pages/finance')),
  FinanceOperatorPayments: lazy(() => import('../pages/finance/operatorPayments')),

  //  Task
  TaskListContainer: lazy(() => import('../pages/tasks/TaskListContainer')),
  Tasks: lazy(() => import('../pages/tasks')),
  TaskTemplates: lazy(() => import('../pages/tasks/templates/TaskTemplateListTab')),
  TaskTemplateEditor: lazy(() => import('../pages/tasks/templates/TaskTemplateEditorPage')),

  // Trip Reports
  TripReports: lazy(() => import('../pages/tripReports')),
  TripReportDetails: lazy(() => import('../pages/tripReports/reportDetails')),

  JetCard: lazy(() => import('../pages/jet-card/jet-card')),
  CreateTeamScreen: lazy(() => import('../pages/URTManagement/team/CreateTeam/CreateTeam')),
  CreateRoleScreen: lazy(() => import('../pages/URTManagement/create-role/CreateRole')),
  ContactListScreen: lazy(() => import('../pages/contact/contact-list/ContactList')),
  AccountListScreen: lazy(() => import('../pages/account/account-list/AccountList')),
  AircraftListScreen: lazy(() => import('../pages/aviation-master-data-management/aircrafts/index')),
  AirportFboListScreen: lazy(() => import('../pages/aviation-master-data-management/aircrafts/AirportFboList')),
  LoginScreen: lazy(() => import('../pages/Login/Login')),
  TeamList: lazy(() => import('../pages/URTManagement/team/TeamList/TeamList')),
  GlobalSearchResults: lazy(() => import('../pages/GlobalSearchResults/index')),

  UserDetails: lazy(() => import('../pages/URTManagement/user/user-details/UserDetails')),
  JetCardList: lazy(() => import('../pages/jet-card/JetCardList')),
  CreateJetCard: lazy(() => import('../pages/create-jet-card/create-jetcard')),
  JetCardPromotionsList: lazy(() => import('../pages/jet-card/JetCardPromotionsList')),
  JetCardAgreements: lazy(() => import('../pages/jet-card/JetCardAgreements')),
  JetCardAdditionalTermsList: lazy(() => import('../pages/jet-card/terms/AdditionalTermsList')),
  JetCardPromotionalTermsList: lazy(() => import('../pages/jet-card/terms/PromotionalTermsList')),
  JetCardStatementList: lazy(() => import('../pages/jet-card/statements/StatementList')),
  Initiation: lazy(() => import('../pages/JetCardAgreementExternal/Initiation-rebrand.component')),
  Thankyou: lazy(() => import('../pages/JetCardAgreementExternal/Thankyou')),
  EmbedJetCard: lazy(() => import('../pages/embed/EmbedJetCard')),
  EmbedOpportunity: lazy(() => import('../pages/embed/EmbedOpportunity')),
  EmbedTrip: lazy(loadEmbedTrip),

  Notifications: lazy(() => import('../pages/Notification/NotificationList')),
  PassengersList: lazy(() => import('../pages/passanger/PassengersList')),

  // Flight Tracking
  FlightTrackingPage: lazy(() => import('../pages/flights/FlightTrackingPage')),

  UnAuthorized: lazy(() => import('../pages/unAuthorized/UnAuthorizedScreen')),

  // Mobile App
  MobileApp: lazy(() => import('../pages/mobile-app')),
};
